import type { Me, Role } from "@/types";

/**
 * 화면 표시용 역할 판정.
 *
 * ⚠️ 이건 **표시용일 뿐**이다. 실제 차단은 서버가 매 요청에서 한다. 메뉴를 숨기는 것만으로는
 * URL 직접 입력을 막을 수 없다.
 *
 * 재무(프로젝트 금액, 개인 임금)는 관리자만 본다. 그리고 **탭을 열어주는 것이 금액을 열어주는
 * 것은 아니다** — 관리자가 아니면 서버가 응답에서 금액 키 자체를 떨어뜨린다.
 */
export const isAdmin = (me: Me | undefined) => me?.role === "admin";

/**
 * 근태와 직원 관리를 볼 수 있는가 — 관리자, 또는 HR 표시가 있는 사람(서버의 require_hr 와 같은 기준).
 * PM 표시는 권한이 없는 이름표라 어떤 화면도 열지 않는다.
 */
export const isHr = (me: Me | undefined) => me?.role === "admin" || !!me?.is_hr;

/** 역할 이름 — 화면에 그대로 보인다. */
export const ROLE_LABEL: Record<Role, string> = {
  admin: "관리자",
  staff: "직원",
};

/** 넓은 역할부터. 목록과 고르기의 순서다. */
export const ROLE_ORDER: Role[] = ["admin", "staff"];
